<template>
  <div class="content has-text-centered">
    <ul
      class="quickMenu"
      :class="{'quickMenu-direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <li :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">
        <router-link :to="'/' + Language + '/trading-account/list'">

          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('account_list').tCapitalizeFirstLetter() }}</h4>
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/account-list.svg" />
          </div>

        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/finance/deposit'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/deposit.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{$t('deposit').tTitle()}}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/finance/withdraw'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/withdraw.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{$t('withdraw').tTitle()}}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/finance/internal-transfer'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/internal-transfer.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('internal_transfer').tCapitalizeFirstLetter() }}</h4>
        </router-link>
      </li>
      <li v-if="!IsDemo && IsVerified">
        <router-link :to="'/' + Language + '/trading-account/create-live'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/live-account.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('open_live_account').tCapitalizeFirstLetter() }}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/trading-account/create-demo'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/demo-account.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('open_demo_account').tCapitalizeFirstLetter() }}</h4>
        </router-link>
      </li>
      <li v-if="IsLive || isIB">
        <router-link :to="'/' + Language + '/profile/upload-documents'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/upload.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('upload_documents').tCapitalizeFirstLetter() }}</h4>
        </router-link>
      </li>
      <li v-if="IsLive && BonusConfig.depositBonus.enabled">
        <router-link :to="'/' + Language + '/finance/my-bonuses'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/bonus.svg" />
          </div>
          <h4>{{ $t('my_bonuses').tCapitalizeFirstLetter() }}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/profile/personal'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/profile.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('my_profile').tCapitalizeFirstLetter() }}</h4>
        </router-link>
      </li>
      <li v-if="isIB">
        <router-link :to="'/' + Language + '/partner/overview'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/partners.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('partners').tTitle() }}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/trading-account/download'">
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/download.svg" />
          </div>
          <h4 :class="{'is-size-6': Language == 'fa' || Language == 'ar'}">{{ $t('download').tTitle() }}</h4>
        </router-link>
      </li>
      <li>
        <a
          v-if="Language=='it'"
          href="https://www.eurotrader.com/it/learn/video-coursi"
          target="_blank"
        >
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/video-courses.svg" />
          </div>
          <h4>{{$t('video_courses')}}</h4>
        </a>
        <a
          v-else-if="Language=='es'"
          href="https://www.eurotrader.com/es/learn/cursos-videos"
          target="_blank"
        >
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/video-courses.svg" />
          </div>
          <h4>{{$t('video_courses')}}</h4>
        </a>
        <a
          v-else-if="Language=='pt'"
          href="https://www.eurotrader.com/pt/learn/video-courses"
          target="_blank"
        >
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/video-courses.svg" />
          </div>
          <h4>{{$t('video_courses')}}</h4>
        </a>
        <a
          v-else-if="Language=='ms'"
          href="https://www.eurotrader.com/ms/learn/video-courses"
          target="_blank"
        >
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/video-courses.svg" />
          </div>
          <h4>{{$t('video_courses')}}</h4>
        </a>
        <a
          v-else-if="Language=='id'"
          href="https://www.eurotrader.com/id/learn/video-courses"
          target="_blank"
        >
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/video-courses.svg" />
          </div>
          <h4>{{$t('video_courses')}}</h4>
        </a>
        <a
          v-else
          href="https://www.eurotrader.com/learn/video-courses/"
          target="_blank"
        >
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/video-courses.svg" />
          </div>
          <h4>{{$t('video_courses')}}</h4>
        </a>
      </li>
      <li>
        <a
          :href="Language!='zh' && Language!='ar'?'https://www.eurotrader.com/'+Language+'/learn/ebooks':'https://www.eurotrader.com/learn/ebooks'"
          target="_blank"
        >
          <div class="quick-icon">
            <img src="../assets/img/icons/quick-menu/ebooks.svg" />
          </div>
          <h4>{{$t('ebooks')}}</h4>
        </a>
      </li>
    </ul>
    <div class="is-clearfix"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['reason'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      IsDemo: 'user/isDemo',
      IsLive: 'user/isLive',
      IsVerified: 'user/isVerified',
      BonusConfig: 'bonusconfig/all',
    }),
    isIB() {
      if (!this.User.accountTypes.length) {
        return false
      }
      return this.User.accountTypes.indexOf('ib') !== -1
    },
  },
  mounted() {},
}
</script>

<style scoped>
#app .content {
  margin-top: -50px;
}
</style>

<style lang="scss">
@import '~bulma/sass/utilities/initial-variables';
@import '../assets/css/variables';

ul.quickMenu {
  padding: 0;
  margin: 0;
  list-style: none;
  li {
    position: relative;
    float: left;
    width: 22%;
    height: 193px;
    border: 1px solid #a4a3c7;
    border-radius: 11px;
    margin: 10px 2% 10px 0;
    list-style: none;
    &:hover {
      border: 1px solid #6826f4;
    }
    @media screen and (max-width: $mobile) {
      width: 47%;
    }
    * {
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      transition: all 0.3s linear;
    }
    a {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      transition: all 0.1s ease-in;
      .quick-icon {
        transition: all 0.1s ease-in;
        height: 70px;
        text-align: right;
        position: absolute;
        bottom: 10px;
        right: 10px;
        > img {
          height: 100%;
        }
      }
      &:hover > .quick-icon {
      }
      h4 {
        color: #10182a;
        margin: 0;
        text-align: left;
        width: 142px;
        font-weight: 700;
        font-family: $family-condensed;
        padding: 0px 20px;
        font-size: 20px;
        margin-top: 20px;
        &:after {
          content: '';
          display: block;
          width: 70%;
          margin: 2px auto 0;
          height: 1px;
        }
      }
      &:hover {
        h4 {
          color: #6826f4;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// QuickMenu.vue?8213e9d6